import { createReducer } from "@reduxjs/toolkit";
import initialState from "./initialState";
// import moment from "moment";
// import _ from 'lodash';
import * as types from "../types/actions";

const authReducer = createReducer(initialState.auth, {
  [types.LOGOUT]: () => initialState.auth,
  [types.LOGIN]: () => ({
    loading: true,
  }),
  [types.LOGIN_SUCCESS]: (_state, action) => ({
    success: action.response.auth,
    token: action.response.token,
    expires: action.response.expires,
    loading: false,
  }),
  [types.LOGIN_FAILURE]: (_state, error) => ({
    success: false,
    error: error,
    loading: false,
  }),
});

export default authReducer;
